module.exports = __webpack_public_path__ + "img/kusa07.e6ebc7a8.png";